import axios from 'axios';
import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBCol, MDBIcon, MDBLightbox, MDBLightboxItem, MDBRow, MDBSmoothScroll, MDBTabs, MDBTabsItem, MDBTabsLink } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import NewReceiptModal from './NewReceiptModal';
import { fetchCompanyMap, fetchDocumentMap } from '../utils/Common';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import { MiscContext } from '../context/MiscProvider';
import TitlesTransformed from './TitlesTransformation';


function TitlesView({ titles=[],  selectDomains, images, setTitles,setEntitiesCreated, firm ,moveTitleToProcessed , setIsTitleToBeProcessed, setShowAlertForUnProcessed}) {
  const [alertMessage, setAlertMessage] = useState('');
  const [activeTab, setActiveTab] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertColor, setAlertColor] = useState('');
  const [isNewReceipt,setIsNewReceipt] = useState(false);
  const { setDocumentsMap,setCompaniesMap} = useContext(MiscContext);
  const {tokenLoaded} = useContext(UserProfileContext);
  const sectionFiveRef = useRef(null);
  const containerFourRef = useRef(null);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  useEffect(() => {
    if (titles && titles?.length > 0) {
   
      setActiveTab(titles?.[0]?.id);
    } else {
    
      setActiveTab(null); // clear active tab
    }
  }, [titles, setTitles]);

  const deleteHandle = async (id) => {
    const url = `${baseUrl}/imgs/${id}`;
    try {
        const response = await axios.delete(url, {
            withCredentials: true,
        });
        if (response.status === 200) {
             // Add the new category to the existing selectCategories state
    setAlertColor("success");
   setShowAlert(true)
    setAlertMessage('Image deleted successfully');
    const updatedTitles = titles.filter(titleItem => titleItem.id !== id);
    setTitles(updatedTitles);

    // Optionally, switch to the first available receipt after removal
    if (updatedTitles.length > 0) {
        setActiveTab(updatedTitles[0].id);
    } else {
        setActiveTab(null);  // No receipt is selected if all are processed
        setIsTitleToBeProcessed && setIsTitleToBeProcessed(false);
    }


    await fetchDocumentMap(setDocumentsMap, tokenLoaded);
    await fetchCompanyMap(setCompaniesMap, tokenLoaded);

        } else {
            console.error('Failed to delete the image');
        }
    } catch (error) {
        console.error('An error occurred while deleting the image:', error);
    }
};
  const handleTabChange = (id) => {
    setActiveTab(id);
  };

  return (
    <section>
      <MDBCard className='text-center'>
        <MDBCardHeader>
          <MDBTabs className='card-header-tabs'>
            { Array.isArray(titles) && titles?.length > 0 && titles?.map((title, index) => (
              <MDBTabsItem key={index}>
                <MDBTabsLink active={activeTab === title?.id} onClick={() => handleTabChange(title.id)}>
                  {title?.name} 
                  <MDBBtn className='ms-2' tag='a' color='none' floating onClick={() => deleteHandle(title.id)} >
                                <MDBIcon fas icon="trash-alt" />
                              </MDBBtn>
                </MDBTabsLink>
              </MDBTabsItem>
            ))}
          </MDBTabs>
        </MDBCardHeader>
        <MDBCardBody>
        <MDBRow className='justify-content-center'>
  {titles?.map((title, index) => (
    activeTab === title.id && (
      <MDBCol key={index} md='12'> 
        <MDBRow>
        

<MDBCol md='3' className='mt-2 mb-2' style={{ overflowY: 'auto', textAlign: 'center', height: '1000px'}}>
            <MDBSmoothScroll
              targetRef={sectionFiveRef}
              containerRef={containerFourRef}
              duration={1000}
              easing={(t) => {
                t /= 0.5;
                if (t < 1) return 0.5 * t * t * t * t;
                t -= 2;
                return -(t * t * t * t - 2) / 2;
              }}
            >
              <MDBLightbox>
                <MDBLightboxItem
                  style={{ width: '100%' }}
                  zoomlevel={0.25}
                  src={title.url}
                  fullscreenSrc={title.url}
                  className="rounded"
                />
              </MDBLightbox>
            </MDBSmoothScroll>
          </MDBCol>

          <MDBCol md='9'>
            <MDBRow>
              <MDBCol> 
                <MDBCardTitle>{title.name}</MDBCardTitle> <NewReceiptModal isNewReceipt={isNewReceipt} setIsNewReceipt={setIsNewReceipt}/>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol>
               <TitlesTransformed title={title}/>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    )
  ))}
</MDBRow>

        </MDBCardBody>
      </MDBCard>

      <MDBAlert open={showAlert}
        color={alertColor}
        position="top-right"
        autohide
        delay={5000}
        appendToBody
        onClose={() => setShowAlert(false)}
      >
        {alertMessage}<MDBBtn tag='a' color='none' className='m-1' style={{ color: '#3b5998' }} onClick={() => setShowAlert(false)}><i className="fas fa-check-circle me-3"></i></MDBBtn>
      </MDBAlert>
    </section>
  );
}

TitlesView.propTypes = {
  selectDomains: PropTypes.array,
  titles: PropTypes.array,
  setTitles: PropTypes.func,
  images: PropTypes.array,
  setEntitiesCreated: PropTypes.func,
  firm: PropTypes.string,
  moveTitleToProcessed: PropTypes.func,
  setIsTitleToBeProcessed: PropTypes.func,
  setShowAlertForUnProcessed: PropTypes.func,
}

export default TitlesView;
